<div class="horizontal-select assignee">
	<p class="select-label">{{ 'assignee' | translate }}</p>

	<au-assignee-select
		type="block"
		[options]="assigneeList$ | async"
		[value]="assigneeControl.value"
		[disableTeamsSelection]="disableTeamsSelection"
		(selectionChange)="setAssignee($event)"
		[placeholder]="'choose' | translate"
	/>
</div>
<div class="horizontal-select approver">
	<p class="select-label">{{ 'responsible' | translate }}</p>

	<au-assignee-select
		type="block"
		[options]="assigneeList$ | async"
		[value]="approverControl.value"
		[disableTeamsSelection]="disableTeamsSelection"
		(selectionChange)="setApprover($event)"
		[placeholder]="'choose' | translate"
	/>
</div>
